import React from 'react';

import { COLORS } from '../../../utils/theme/colors';

const Polygon = ({ fill = COLORS.lightDarkText, className = '' }) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.30718 6.2C9.6151 5.66667 10.3849 5.66667 10.6928 6.2L13.6373 11.3C13.9452 11.8333 13.5603 12.5 12.9445 12.5H7.05551C6.43967 12.5 6.05477 11.8333 6.36269 11.3L9.30718 6.2Z" fill={fill} />
    </svg>
  );
};

export default Polygon;
